import React from 'react';

import { Modal } from 'src/components/common';
import { UnfreezeYourAccountModalContent } from 'src/components/consumer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { UnfreezeYourAccountModalModalArgs } from './types';

export const UnfreezeYourAccountModal: React.FC = () => {
  const { closeModal, isOpen, switchClosability, args } =
    useModal<UnfreezeYourAccountModalModalArgs>(ModalId.UnfreezeYourAccountModal);
  const userInfo = args;

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={550}
    >
      <UnfreezeYourAccountModalContent
        consumer={userInfo?.consumer}
        switchClosability={switchClosability}
        onCloseModal={onCloseModal}
      />
    </Modal>
  );
};
